export default __webpack_public_path__ + "static/media/bg05.cede60de.jpg";